import axios from "axios";
import { toast } from "react-toastify";
import { apiBaseUrl } from "../SEO/APIUrl";
import { errorToast } from "../../helper/toastHelper";

const apiClient = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const authData = localStorage.getItem("auth");
    const visitor = localStorage.getItem("visitor");
    const language = localStorage.getItem("language") || "en";
    config.headers["lang"] = language;

    if (authData) {
      const { token } = JSON.parse(authData);
      if (token) {
        config.headers["Authorization"] = `Token ${token}`;
      } else if (visitor) {
        config.headers["Visitor"] = visitor;
      }
    } else if (visitor) {
      config.headers["Visitor"] = visitor;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      window.location.pathname !== "/login"
    ) {
      errorToast("Session expired. Please log in again.");
      localStorage.removeItem("token");
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default apiClient;
